import React from "react";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, CardImg, CardBody, Badge, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";

const ShowcaseCard = ({
  title,
  category,
  description,
  labels,
  tags,
  buttonText,
  img,
  targetPath,
}) => {
  return (
    <Card className="otm-card rounded">
      <span className="card-top-text">{category}</span>
      <CardImg
        top
        className="rounded-top"
        width="100%"
        src={require("../../assets/img/" + img)}
        alt=" "
      />
      <CardBody className="rounded-bottom">
        <div className="card-between">
          {labels &&
            labels.map((label) => (
              <Badge key={label} className="card-badge" color="light">
                {label}
              </Badge>
            ))}
        </div>
        <CardTitle>{title}</CardTitle>
        <div>
          {tags &&
            tags.map((tag) => (
              <Badge key={tag} className="card-pill" color="light" pill>
                {tag}
              </Badge>
            ))}
        </div>
      </CardBody>

      <div className="reveal rounded">
        <div className="reveal-top">
          {labels &&
            labels.map((label) => (
              <Badge key={label} className="card-badge" color="light">
                {label}
              </Badge>
            ))}
        </div>
        <CardTitle>{title}</CardTitle>
        <div className="reveal-body">{description}</div>
        <Link to={targetPath}>
          <button className="btn reveal-button">{buttonText}</button>
        </Link>
      </div>
    </Card>
  );
};

ShowcaseCard.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.string,
  description: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.string,
  img: PropTypes.string.isRequired,
};

ShowcaseCard.defaultProps = {
  category: "",
  labels: [],
  tags: [],
  buttonText: "자세히",
};

export default ShowcaseCard;
